import { AuthService } from "../index";

export default function user({ next, router }) {
  if (
    AuthService.user["student"] === null &&
    AuthService.user["profile_status"] === "new"
  ) {
    return router.replace({
      name: "ApplicationTabs",
    });
  }
  return next();
}
